import { render, staticRenderFns } from "./TargetDateCard.vue?vue&type=template&id=8eed2d64"
import script from "./TargetDateCard.vue?vue&type=script&lang=js"
export * from "./TargetDateCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports